import { Document } from './Document'
import { Format } from './Format'

class Sheet extends Document {
  pages
  order
  format

  constructor (ref, data) {
    super(ref)

    if (data.pages.length < 1) {
      throw new Error('The number of pages must be greater than zero')
    }

    if (data.pages.length > 2) {
      throw new Error('The number of pages cannot be more than two')
    }

    this.pages = data.pages
    this.order = data.order
    this.format = new Format(data.format)
  }

  get leftPage () {
    return this.pages.find((page) => page.side === 'left')
  }

  get rightPage () {
    return this.pages.find((page) => page.side === 'right')
  }

  get isCover () {
    return false
  }

  /* Полная ширина листа. У обложки переопределяется — там добавляется корешок. */
  get totalWidthMm () {
    return this.format.width * this.pages.length
  }

  get aspectRatio () {
    return this.totalWidthMm / this.format.height
  }

  render (contenteditable = false, rootEl = document) {
    return this.#renderLayout(contenteditable, rootEl) + this.#renderStyle()
  }

  toObject () {
    const data = super.toObject()
    data.pages = data.pages.map((page) => page._ref)
    data.format = JSON.parse(JSON.stringify(data.format))
    return data
  }

  clone () {
    const pages = this.pages.map((page) => page.clone())
    return new Sheet(this._ref, Object.assign(JSON.parse(this.toJSON()), { pages }))
  }

  #renderLayout (contenteditable = false, rootEl = document) {
    const renderedLeftPage = this.leftPage?.render(contenteditable, rootEl) || ''
    const renderedRightPage = this.rightPage?.render(contenteditable, rootEl) || ''
    const renderedPages = renderedLeftPage + renderedRightPage
    return `<div class="sheet" id="${this._id}">${renderedPages}</div>`
  }

  #renderStyle () {
    return `
      <style>
        #${this._id}.sheet {
          width: calc(${this.pages.length} * ${this.format.getCssWidth()});
          height: ${this.format.getCssHeight()};
          background: white;
          display: flex;
        }
      </style>
    `
  }
}

export { Sheet }
